import { defineComponent as C, useAttrs as E, useSlots as V, useCssModule as A, computed as s, createElementBlock as d, openBlock as i, unref as o, normalizeClass as n, withDirectives as B, createElementVNode as x, createCommentVNode as z, mergeProps as M, vModelCheckbox as $, renderSlot as k, createTextVNode as w, toDisplayString as h } from "vue";
import I from "@leaflink/snitch";
import m from "lodash-es/uniqueId";
import { _ as N } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const S = ["data-test"], D = ["id", "aria-invalid", "aria-errormessage", "disabled", "value"], q = ["for"], H = ["id"], P = /* @__PURE__ */ C({
  name: "ll-checkbox",
  inheritAttrs: !1,
  __name: "Checkbox",
  props: {
    checked: { type: [Boolean, Array], default: !1 },
    hasError: { type: Boolean, default: !1 },
    id: { default: void 0 },
    label: { default: void 0 },
    errorText: { default: "" },
    hintText: { default: "" },
    modelValue: { type: [Boolean, Array], default: void 0 },
    value: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:checked"],
  setup(v, { emit: f }) {
    const e = v, a = E(), _ = V(), l = A(), y = f;
    if (e.modelValue !== void 0)
      throw new Error("ll-checkbox: use :checked or v-model:checked instead of :model-value and v-model.");
    if (typeof e.value == "boolean" && I.warn("ll-checkbox: use `checked` to toggle the state; `value` is what will be set if `checked` is true"), a.onChange)
      throw new Error("ll-checkbox: use the @update:checked event instead of @change.");
    const g = s(() => {
      const t = { ...a };
      return delete t["data-test"], delete t.class, t;
    }), r = s({
      get() {
        return e.checked;
      },
      set(t) {
        y("update:checked", t);
      }
    }), c = s(() => !!e.errorText || e.hasError), u = s(() => e.id || m("checkbox-")), b = s(() => e.errorText ? m("checkbox-error-") : void 0);
    return (t, p) => (i(), d("div", {
      class: n(["stash-checkbox tw-relative tw-m-0", [
        o(a).class,
        {
          "stash-checkbox--checked": !!r.value,
          [`stash-checkbox--has-error ${o(l)["has-error"]}`]: c.value
        }
      ]]),
      "data-test": o(a)["data-test"] || "stash-checkbox"
    }, [
      B(x("input", M({
        id: u.value,
        "onUpdate:modelValue": p[0] || (p[0] = (T) => r.value = T),
        "aria-invalid": !!e.errorText,
        "aria-errormessage": b.value,
        disabled: e.disabled,
        class: ["tw-sr-only lg:tw-m-0", o(l).input],
        type: "checkbox",
        value: t.value
      }, g.value), null, 16, D), [
        [$, r.value]
      ]),
      x("label", {
        "data-test": "stash-checkbox|label",
        class: n(["stash-checkbox__label tw-relative tw-inline-block tw-min-h-9 tw-cursor-pointer tw-overflow-visible tw-py-1.5 tw-pl-8 tw-align-top tw-text-sm tw-font-normal tw-leading-6", [
          o(l).label,
          {
            "tw-text-ice-900": !c.value && !e.disabled,
            "tw-text-red-500": c.value,
            "tw-text-ice-500": e.disabled
          }
        ]]),
        for: u.value
      }, [
        k(t.$slots, "default", {}, () => [
          w(h(t.label), 1)
        ])
      ], 10, q),
      e.errorText ? (i(), d("span", {
        key: 0,
        id: b.value,
        class: "stash-checkbox__error-text tw-ml-8 tw-block tw-whitespace-pre-line tw-text-xs tw-text-red-500",
        "data-test": "stash-checkbox|error"
      }, h(e.errorText), 9, H)) : e.hintText || o(_).hint ? (i(), d("span", {
        key: 1,
        class: n(["stash-checkbox__hint-text tw-ml-8 tw-block tw-whitespace-pre-line tw-text-xs", { "tw-text-ice-500": e.disabled }]),
        "data-test": "stash-checkbox|hint"
      }, [
        k(t.$slots, "hint", {}, () => [
          w(h(e.hintText), 1)
        ])
      ], 2)) : z("", !0)
    ], 10, S));
  }
}), U = "_input_bhz1o_2", j = "_label_bhz1o_2", F = {
  input: U,
  label: j,
  "has-error": "_has-error_bhz1o_23"
}, G = {
  $style: F
}, Q = /* @__PURE__ */ N(P, [["__cssModules", G]]);
export {
  Q as default
};
//# sourceMappingURL=Checkbox.js.map
